import React, {useEffect, useState} from 'react'
import './EditSensorModal.scss'
import { useDispatch, useSelector } from "react-redux";
import {getSensors, selectSensor, updateSensorDetails} from "../store/actions/sensorsActions";

const selector = state => {
    const { language, disableButtons, sensors } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        selected: sensors.selected,
    }
};

const EditSensorModal = props => {
    const { t, selected } = useSelector(selector);
    const { closeMethod,reload, editType, loadSensors } = props;
    const dispatch = useDispatch();

   
    const [sensorName, setSensorName] = useState('')
    const [latitude, setLatitude] = useState('')
    const [longitude, setLongitude] = useState('')

    useEffect(() => {
        if (selected?.sensor) {
            if (editType === 'name') {
                setSensorName(selected.sensor.name || '')
            } else {
                setLatitude(selected.sensor.latitude || '')
                setLongitude(selected.sensor.longitude || '')
            }
        }
    }, [selected, editType]);

    const handleSaveClick = async () => {
        if (!selected?.sensor?.id) return;
        const updateData = editType === 'name'
            ? { name: sensorName }
            : { latitude, longitude };

        await dispatch(updateSensorDetails({...updateData, id: selected.sensor.id}))
        await loadSensors()
        dispatch(selectSensor(selected?.sensor, 1))
        reload()
        closeMethod()

    }


    return (
        <div className="editSensorContainer">
            <div className='editHeader'>
                {t.gettext('Edit Sensor')}
            </div>

            {editType === 'name' ? (
                <div className='fieldFormItem'>
                    <label className='fieldFormLabel'>
                        {t.gettext('Sensor Name')}
                    </label>
                    <input
                        className='editInput'
                        value={sensorName}
                        onChange={e => setSensorName(e.target.value)}
                        type='text'
                    />
                </div>
            ) : (
                <>
                    <div className='fieldFormItem'>
                        <label className='fieldFormLabel'>
                            {t.gettext('Latitude')}
                        </label>
                        <input
                            className='editInput'
                            value={latitude}
                            onChange={e => setLatitude(e.target.value)}
                            type='number'
                            step="0.000001"
                        />
                    </div>
                    <div className='fieldFormItem'>
                        <label className='fieldFormLabel'>
                            {t.gettext('Longitude')}
                        </label>
                        <input
                            className='editInput'
                            value={longitude}
                            onChange={e => setLongitude(e.target.value)}
                            type='number'
                            step="0.000001"
                        />
                    </div>
                </>
            )}

            <div className="editBtnWrapper">
                <button
                    className='editBtn saveBtn'
                    onClick={e => {
                        e.preventDefault();
                        handleSaveClick()
                    }}
                    disabled={editType === 'name'
                        ? !sensorName
                        : !latitude || !longitude}
                >
                    {t.gettext('Save')}
                </button>
                <button
                    className='editBtn cancelBtn'
                    onClick={e => {
                        e.preventDefault();
                        closeMethod()
                    }}
                >
                    {t.gettext('Cancel')}
                </button>
            </div>
        </div>
    )
}

export default EditSensorModal
